import axios from "../../../api/axios";
import { fetchDeviations } from "../../../api/quality/deviation";
import { fetchChecklists } from "../../../api/quality/checklist";

const DEVIATION_FIELDS =
  "id,number,displayTitle,title,status,priority,severity,description,place,project,created_by,created_at,deviation_date,deviation_type";

const CHECKLIST_FIELDS =
  "id,number,displayTitle,title,status,items.id,items.displayTitle,items.title,items.isApproved,items.isDeviation,items.is_not_applicable,items.response_code";

export const loadProjectDeviations = async (projectId) => {
  if (!projectId) return [];

  const response = await fetchDeviations({
    page: 1,
    per_page: 100,
    sort: "desc",
    sortBy: "updated_at",
    fields: DEVIATION_FIELDS,
    filters: [{ name: "project", value: String(projectId) }],
  });

  return response?.data || [];
};

export const loadDrawingLocationOptions = async (projectId) => {
  const response = await axios({
    method: "get",
    url: "/drawings/location_options",
    params: projectId ? { project_id: projectId } : {},
  });

  return {
    houses: response.data?.houses || [],
    floors: response.data?.floors || [],
  };
};

export const loadProjectChecklists = async (projectId) => {
  if (!projectId) return [];

  const response = await fetchChecklists({
    page: 1,
    per_page: 50,
    sort: "desc",
    sortBy: "updated_at",
    fields: CHECKLIST_FIELDS,
    filters: [{ name: "project", value: String(projectId) }],
  });

  return response?.data || [];
};
